// Builds JSON-LD structured data (schema.org) for the current route.
//
// Returned as a single @graph so it can be injected as one
// <script type="application/ld+json"> tag. App.vue feeds the active route in,
// so each prerendered page gets its own correct schema.

const BASE_URL = "https://fintech.somaniglobal.com";
const ORG_ID = `${BASE_URL}/#organization`;

const ORGANIZATION = {
  "@type": "Organization",
  "@id": ORG_ID,
  name: "Somani Global",
  url: BASE_URL,
  logo: `${BASE_URL}/assets/logos/logo.png`,
  email: "minal@somaniglobal.com",
  telephone: "+1-302-601-0115",
  sameAs: ["https://somaniglobal.com"],
  address: [
    {
      "@type": "PostalAddress",
      streetAddress: "447 Broadway, 2nd Floor",
      addressLocality: "New York",
      addressRegion: "NY",
      postalCode: "10013",
      addressCountry: "US",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "310 Morya Estate, Link Road, Andheri (West)",
      addressLocality: "Mumbai",
      postalCode: "400053",
      addressCountry: "IN",
    },
  ],
};

const WEBSITE = {
  "@type": "WebSite",
  "@id": `${BASE_URL}/#website`,
  url: BASE_URL,
  name: "Somani Global",
  publisher: { "@id": ORG_ID },
};

// Mirrors the FAQs hardcoded in src/components/FAQSection.vue (homepage).
// Keep in sync if those change.
const HOME_FAQS = [
  {
    question: "Which jurisdiction is best for my crypto business?",
    answer:
      "It depends on your use case, cost, compliance needs, and banking requirements. EU MiCA and Canada are currently very popular.",
  },
  {
    question: "How long does the process take?",
    answer:
      "The average time to obtain a license is between 3 to 9 months, depending on the jurisdiction and readiness of documentation.",
  },
  {
    question: "Do you provide ongoing compliance support?",
    answer:
      "Yes. Our team provides full ongoing support for AML, reporting, and annual reviews.",
  },
];

const CRYPTO_COUNTRIES = {
  canada: "Canada",
  singapore: "Singapore",
  varadubai: "Dubai (VARA)",
  dubai: "Dubai",
  estonia: "Estonia",
  lithuania: "Lithuania",
  czechrepublic: "Czech Republic",
  elsalvador: "El Salvador",
  tbilisifreezone: "Tbilisi Free Zone, Georgia",
  micaregulation: "European Union (MiCA)",
  poland: "Poland",
  mauritius: "Mauritius",
};

const GAMING_COUNTRIES = {
  indian: "India",
  anjouan: "Anjouan",
  "costa-rica": "Costa Rica",
  malta: "Malta",
  portugal: "Portugal",
  panama: "Panama",
  romania: "Romania",
};

const COMPANY_REG_COUNTRIES = {
  usa: "USA",
  uae: "UAE",
  singapore: "Singapore",
  panama: "Panama",
  canada: "Canada",
  bvi: "B.V.I",
  lithuania: "Lithuania",
  estonia: "Estonia",
  czechrepublic: "Czech Republic",
  cyprus: "Cyprus",
  romania: "Romania",
  seychelles: "Seychelles",
  poland: "Poland",
  france: "France",
  uk: "UK",
  mauritius: "Mauritius",
  southafrica: "South Africa",
  nigeria: "Nigeria",
};

export function buildStructuredData(route) {
  const path = route.path;
  const canonical = BASE_URL + path;
  const graph = [ORGANIZATION, WEBSITE];

  let country;
  let licenseLabel;
  let serviceType;
  let serviceName;

  if (path.startsWith("/services/crypto-license/")) {
    country = CRYPTO_COUNTRIES[path.split("/").pop()];
    licenseLabel = "Crypto License";
    serviceType = "Crypto licensing & VASP registration";
  } else if (path.startsWith("/services/gaming-license/")) {
    country = GAMING_COUNTRIES[path.split("/").pop()];
    licenseLabel = "Gaming License";
    serviceType = "Gaming & gambling license consulting";
  } else if (path.startsWith("/services/company-registration/")) {
    country = COMPANY_REG_COUNTRIES[path.split("/").pop()];
    serviceType = "Company formation & registration";
    if (country) serviceName = `Company Registration in ${country}`;
  }

  if (country) {
    if (!serviceName) serviceName = `${country} ${licenseLabel}`;
    graph.push({
      "@type": "Service",
      name: serviceName,
      serviceType,
      provider: { "@id": ORG_ID },
      areaServed: country,
      description: (route.meta && route.meta.description) || "",
      url: canonical,
    });
    graph.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${BASE_URL}/` },
        { "@type": "ListItem", position: 2, name: serviceName, item: canonical },
      ],
    });
  }

  if (path === "/") {
    graph.push({
      "@type": "FAQPage",
      mainEntity: HOME_FAQS.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    });
  }

  return { "@context": "https://schema.org", "@graph": graph };
}
